/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/service/config.service';

/**
 * Base service for Customer API calls.
 * Auth headers are injected automatically by AuthInterceptor.
 * Domain-specific services (bookmark, filter, alerts, etc.) inject this service.
 */
@Injectable({
  providedIn: 'root',
})
export class CustomerApiService {
  private baseUrl: string;

  constructor(
    protected http: HttpClient,
    protected config: ConfigService,
  ) {
    this.baseUrl = this.config.appConfig.urlCustomerApi;
  }

  getUrl(endpoint: string): string {
    return `${this.baseUrl}${endpoint}`;
  }

  get<T>(endpoint: string, params?: Record<string, string>): Observable<T> {
    return this.http.get<T>(this.getUrl(endpoint), { params });
  }

  getText(
    endpoint: string,
    params?: Record<string, string>,
  ): Observable<string> {
    return this.http.get(this.getUrl(endpoint), {
      params,
      responseType: 'text',
    });
  }

  getBlob(endpoint: string, params?: Record<string, string>): Observable<Blob> {
    return this.http.get(this.getUrl(endpoint), {
      params,
      responseType: 'blob',
    });
  }

  post<T>(endpoint: string, body: any): Observable<T> {
    return this.http.post<T>(this.getUrl(endpoint), body);
  }

  postText(endpoint: string, body: any): Observable<string> {
    return this.http.post(this.getUrl(endpoint), body, {
      responseType: 'text',
    });
  }

  put<T>(endpoint: string, body: any): Observable<T> {
    return this.http.put<T>(this.getUrl(endpoint), body);
  }

  delete<T>(endpoint: string, params?: Record<string, string>): Observable<T> {
    return this.http.delete<T>(this.getUrl(endpoint), { params });
  }

  deleteWithBody<T>(endpoint: string, body: any): Observable<T> {
    return this.http.request<T>('delete', this.getUrl(endpoint), { body });
  }
}
